import axios from 'axios'
import utils from './utils'

const load = async (url, signal = null, defaultValue = null) => {
  try {
    const params = {}
    if (signal) params.signal = signal
    const res = await axios.get(url, params)
    return res.data
  } catch (ex) {
    console.error(ex)
    return defaultValue
  }
}

const getAll = async (entity, signal = null) => {
  const url = `${utils.url}/${entity}`
  return await load(url, signal, [])
}

const add = async (entity, data, signal = null) => {
  const url = `${utils.url}/${entity}`
  try {
    const params = {}
    if (signal) params.signal = signal
    const res = await axios.post(url, data, params)
    return res.data
  } catch (ex) {
    console.error(ex)
    return null
  }
}

/*
 * data must be a js object with id property
 */
const delete_ = async (entity, id, signal = null) => {
  const url = `${utils.url}/${entity}/${id}`
  try {
    const params = {}
    if (signal) params.signal = signal
    const res = await axios.delete(url, params)
    return res.data
  } catch (ex) {
    console.error(ex)
    return null
  }
}

const update = async (entity, data, signal = null) => {
  const url = `${utils.url}/${entity}`
  try {
    const params = {}
    if (signal) params.signal = signal
    const res = await axios.put(url, data, params)
    return res.data
  } catch (ex) {
    console.error(ex)
    return null
  }
}

const put = async (url, data, signal = null) => {
  try {
    const params = {}
    if (signal) params.signal = signal
    const res = await axios.put(url, data, params)
    return res.data
  } catch (ex) {
    console.error(ex)
    return null
  }
}

const post = async (url, data, signal = null) => {
  try {
    const params = {}
    if (signal) params.signal = signal
    const res = await axios.post(url, data, params)
    return res.data
  } catch (ex) {
    console.error(ex)
    return null
  }
}

const getAllBy = async (parentEntity, parentId, childEntity, signal = null) => {
  const url = `${utils.url}/${parentEntity}/${parentId}/${childEntity}`
  return await load(url, signal, [])
}

const get = async (entity, id, signal = null) => {
  const url = `${utils.url}/${entity}/${id}`
  return await load(url, signal)
}

export default { load, getAll, get, getAllBy, add, update, delete_, put, post }
